import i18next, { t } from "i18next";
import moment from "moment-timezone";
import { confirmAlert } from "react-confirm-alert";
import { Trans, useTranslation } from "react-i18next";

export let defaultAlertMessages = {
  TittleError: <Trans>{t("warning")}</Trans>,
  TittleWarning: <Trans>{t("warning")}</Trans>,
  TittleSuccess: <Trans>{t("success")}</Trans>,
  MessageDetailError: <Trans>{t("please_try_again")}</Trans>,
  MessageDetailWarning: <Trans>{t("sure_continue")}</Trans>,
  MessageDetailSuccess: <Trans>{t("successfully_completed")}</Trans>,
  Ok: <Trans>{t("ok")}</Trans>,
  Yes: <Trans>{t("yes")}</Trans>,
  No: <Trans>{t("no")}</Trans>,
};

export const serviceMessageSuccess = (message) => {
  if (message && typeof message === "string") {
    message = message.match(/^['"].*['"]$/)
      ? message.replace(/^['"](.*)['"]$/, "$1")
      : message;
  }

  defaultAlertMessages.MessageDetailSuccess = t(message);
  confirmAlert({
    customUI: ({ onClose }) => {
      return getConfirmSuccessMessage(onClose, defaultAlertMessages);
    },
  });
};

export const serviceMessageError = (message) => {
  if (message && typeof message === "string") {
    message = message.match(/^['"].*['"]$/)
      ? message.replace(/^['"](.*)['"]$/, "$1")
      : message;
  }

  defaultAlertMessages.MessageDetailError = t(message);
  confirmAlert({
    customUI: ({ onClose }) => {
      return getConfirmErrorMessage(onClose, defaultAlertMessages);
    },
  });
};

export const getConfirmSuccessMessage = (onClose, objMessageInfo) => {
  let messageDetail = objMessageInfo?.MessageDetailSuccess || "";

  if (messageDetail && typeof messageDetail === "string") {
    messageDetail = messageDetail.match(/^['"].*['"]$/)
      ? t(messageDetail.replace(/^['"](.*)['"]$/, "$1"))
      : t(messageDetail);
  }

  return (
    <div className="eConfirm">
      <div className="circle-wrapper">
        <div className="success circle"></div>
        <div className="success-icon  icon">
          <i className="fa fa-check"></i>
        </div>
      </div>
      <h2 className="text-center">{objMessageInfo.TittleSuccess}</h2>
      <hr></hr>
      <p>{messageDetail}</p>
      <div className="eConfirmButtons text-center">
        <button className="k-button btn-success w-50" onClick={onClose}>
          {objMessageInfo.Ok}
        </button>
      </div>
    </div>
  );
};

export const getConfirmErrorMessage = (onClose, objMessageInfo) => {
  let messageDetail = objMessageInfo?.MessageDetailError || "";

  if (messageDetail && typeof messageDetail === "string") {
    messageDetail = messageDetail.match(/^['"].*['"]$/)
      ? t(messageDetail.replace(/^['"](.*)['"]$/, "$1"))
      : t(messageDetail);
  }

  return (
    <div className="eConfirm">
      <div className="circle-wrapper">
        <div className="error circle"></div>
        <div className="error-icon icon">
          <i className="fa fa-times"></i>
        </div>
      </div>
      <h2 className="text-center">{objMessageInfo.TittleError}</h2>
      <hr></hr>
      <p>{messageDetail}</p>
      <div className="eConfirmButtons text-center">
        <button className="k-button btn-primary w-50" onClick={onClose}>
          {objMessageInfo.Ok}
        </button>
      </div>
    </div>
  );
};

export const NoMatch = () => {
  const { t } = useTranslation();
  return <p>{t("not_found")}</p>;
};

export const getLocalDate = (value, timezone) => {
  if (!value) return null;
  const dateValue = value instanceof Date ? value : new Date(value);
  if (isNaN(dateValue.getTime())) return null;

  const obj = {
    year: dateValue.getFullYear(),
    month: dateValue.getMonth(),
    day: dateValue.getDate(),
    hour: dateValue.getHours(),
    minute: dateValue.getMinutes(),
    second: dateValue.getSeconds(),
  };

  return moment.tz(obj, timezone).format();
};

/**
 * Seçilen dil e göre mail template parametrelerini döner.
 * @returns {Array}
 */
export const getAllMailTemplateParameters = () => {
  const resources = i18next.getResourceBundle(i18next.language, "translation");
  if (!resources || !resources.mail_template_parameters) return [];
  return Object.keys(resources.mail_template_parameters);
};

/**
 * Seçilen dil e göre mail template parametrelerini döner.
 * @returns {Array}
 */
export const getAllInvitationTemplateParameters = () => {
  const resources = i18next.getResourceBundle(i18next.language, "translation");
  if (!resources || !resources.invitation_template_parameters) return [];
  return Object.keys(resources.invitation_template_parameters);
};
